import React from 'react';
import { isMobile } from 'react-device-detect';
import NumberFormat from 'react-number-format';
import { useHistory } from "react-router-dom";

function Slider({products}) {
	const history = useHistory();
	return (
		<div id="slider" className="section-container p-0 bg-dark shadow">
			<div id="main-carousel" className="carousel slide" data-ride="carousel">
				<div className="carousel-inner">
					{products.results.map((p, i) => {
						let nextLink = p?.code ? '/produk/'+p?.code : ''
						let fadeIn = i%2==0 ? 'Right' : 'Left'
						let captionIn = i%2==0 ? 'left' : 'right'
						if (isMobile) {
							return (
								<div key={i} className={i==0? "carousel-item active bg-white" : "carousel-item bg-white"} data-paroller="true" data-paroller-factor="0.3" data-paroller-factor-sm="0.01" data-paroller-factor-xs="0.01">
									<div className="container">
										<img style={{objectFit: 'contain', width: 360}} src={p?.image?.url} className={"animated"} alt="" />
									</div>
									<div className={"carousel-caption carousel-caption-"+captionIn+" text-black"}>
										<div className="container">
											<h3 style={{textAlign: captionIn}} className={fadeIn+"Big animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent sm:pb-4 px-2 sm:px-0 px-sm-0 text-3xl md:text-5xl font-black"}>
												{p.name}
											</h3>
										</div>
									</div>
									<div style={{top: 'auto'}} className={"carousel-caption carousel-caption-"+captionIn+" text-black"}>
										<div className="flex justify-between">
											<div style={{marginLeft: 10}}>
												<div style={{textAlign: 'left'}}>From</div>
												<div className="price"><span><NumberFormat value={p?.unit_price?.min} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '}/></span></div>
											</div>
											<div style={{marginRight: 10}}>
												<div style={{textAlign: 'right'}}>{p.type=='ready_stock' ? 'Tersedia ' + p?.quantity?.available + ' Pcs' : 'Pre Order'}</div>
												<button style={{ border: '2px solid #2d353c', backgroundColor: 'rgba(255, 255, 255, .5)', color: '#2d353c', fontWeight: 600}} onClick={() => history.push(nextLink)} className={"py-2 px-2 rounded-lg btn-outline"}>Pesan Sekarang</button>
											</div>
										</div>
									</div>
								</div>
							)
						} else {
							return (
								<div key={i} className={i==0? "carousel-item active bg-white" : "carousel-item bg-white"} data-paroller="true" data-paroller-factor="0.3" data-paroller-factor-sm="0.01" data-paroller-factor-xs="0.01">
									<div className="container">
										<img style={{objectFit: 'contain', width: 360}} src={p?.image?.url} className={"product-img "+fadeIn.toLowerCase()+" bottom fadeIn"+fadeIn+" animated"} alt="" />
									</div>
									<div className={"carousel-caption carousel-caption-"+captionIn+" text-black"}>
										<div className="container">
											<button onClick={() => history.push(nextLink)} style={{background: 'none', border: 'none', padding: 0}}>
												<h3 
													className={fadeIn+"Big animate-text bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent sm:pb-4 px-2 sm:px-0 px-sm-0 text-3xl md:text-5xl font-black"} 
													style={{textAlign: captionIn}}>
													{p.name}
												</h3>
											</button>
											<p className={"mb-4 fadeIn"+fadeIn+"Big animated"}>{p.type=='ready_stock' ? 'Tersedia ' + p?.quantity?.available + ' Pcs' : 'Pre Order'}</p>
											<div className={"price mb-30px fadeIn"+fadeIn+"Big animated"}><small className='bg-white px-2 opacity-75'>from</small> <span><NumberFormat value={p?.unit_price?.min} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '}/></span></div>
											<button onClick={() => history.push(nextLink)} className={"btn btn-outline btn-lg"}>Pesan Sekarang</button>
										</div>
									</div>
								</div>
							)
						}
					})}
				</div>
				<a className="carousel-control-prev" href="#main-carousel" data-bs-slide="prev"> 
					<i className="fa fa-angle-left"></i> 
				</a>
				<a className="carousel-control-next" href="#main-carousel" data-bs-slide="next"> 
					<i className="fa fa-angle-right"></i> 
				</a>
			</div>
		</div>
	)
}

export default Slider;



